export const FEEDBACK_CATEGORIES = ["bug", "idea", "usability", "other"] as const;
export type Feedback = { category: (typeof FEEDBACK_CATEGORIES)[number]; message: string; contactEmail?: string };

export function parseFeedback(value: unknown): Feedback {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("回饋格式不正確。");
  const body = value as Record<string, unknown>;
  if (Object.keys(body).some((key) => !["category", "message", "contactEmail"].includes(key)))
    throw new Error("回饋只可包含你填寫的類別、內容及跟進電郵。");
  if (!FEEDBACK_CATEGORIES.includes(body.category as Feedback["category"])) throw new Error("請選擇回饋類別。");
  if (typeof body.message !== "string" || !body.message.trim() || body.message.trim().length > 2000)
    throw new Error("請填寫 1 至 2000 字的回饋內容。");
  const contactEmail = typeof body.contactEmail === "string" ? body.contactEmail.trim() : undefined;
  if (
    body.contactEmail !== undefined &&
    (!contactEmail || contactEmail.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactEmail))
  )
    throw new Error("請填寫有效的跟進電郵，或取消電郵跟進。");
  return {
    category: body.category as Feedback["category"],
    message: body.message.trim(),
    ...(contactEmail ? { contactEmail } : {}),
  };
}
